module.exports = __webpack_public_path__ + "img/tc-icon.ebfbf61a.png";